<template>
  <footer>
    <div class="footer-content">
      <div class="footer-logo">
        <div class="logo-icon">
          <img :src="logoSrc" alt="Logo" />
        </div>
        <span class="logo-text">Feedax</span>
      </div>
      <p class="footer-text">© 2026 Feedax. All rights reserved.</p>
      <a
        class="footer-icp"
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
        >京ICP备11029513号-15</a
      >
    </div>
  </footer>
</template>

<script setup>
  import { computed, inject } from 'vue'
  import logoDark from '@/assets/logo.png'
  import logoLight from '@/assets/logo1.png'

  const theme = inject('theme')

  const logoSrc = computed(() => {
    return theme.value === 'dark' ? logoDark : logoLight
  })
</script>

<style scoped>
  footer {
    position: relative;
    z-index: 10;
    padding: 40px 32px;
    border-top: 1px solid var(--border-color);
    background: var(--bg-secondary);
    backdrop-filter: blur(20px);
  }

  [data-theme='dark'] footer {
    background: rgba(15, 23, 42, 0.95);
  }

  .footer-content {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .footer-logo {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .footer-logo .logo-icon {
    width: 32px;
    height: 32px;
    /* border-radius: 50%; */
    overflow: hidden;
  }

  .footer-logo .logo-icon img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }

  .footer-text {
    color: var(--text-secondary);
    font-size: 14px;
  }

  .footer-icp {
    color: var(--text-secondary);
    font-size: 14px;
    text-decoration: none;
  }

  .footer-icp:hover {
    color: var(--primary);
  }
</style>
